import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IFilterItem } from "../models/filter-item-model";
import IFilterGroup, { IFilterGroupViewModel } from "../models/filter-group-model";

class FilterMapper {
    public filterGroupList(filters: IFilterGroup[]): string[] {
        return filters.map((x: IFilterGroup) => x.DisplayName);
    }

    public filterGroups(filters: IFilterGroup[]): IDictionary<IFilterGroupViewModel> {
        let dict: IDictionary<IFilterGroupViewModel> = {};

        filters.forEach((filterGroup: IFilterGroup) => {
            dict[filterGroup.DisplayName] = {
                UseImplicitFilters: filterGroup.UseImplicitFilters,
                FilterItems: filterGroup.FilterItems.map(x => x.FilterCodeName)
            };
        });

        return dict;
    }

    public filterItems(filters: IFilterGroup[]): IDictionary<IFilterItem> {
        let filterItems: IDictionary<IFilterItem> = {};

        filters.forEach((filterGroup: IFilterGroup) => {
            filterGroup.FilterItems.forEach((filterItem: IFilterItem) => {
                filterItem.FilterGroup = filterGroup.DisplayName;
                filterItems[filterItem.FilterCodeName] = filterItem;
            });
        })

        return filterItems;
    }

    public scopes(scopes: IFilterGroup): IDictionary<IFilterItem> {
        let filterItems: IDictionary<IFilterItem> = {};

        if (scopes) {
            scopes.FilterItems.forEach((scope: IFilterItem) => {
                filterItems[scope.FilterCodeName] = scope;
            });
        }

        return filterItems;
    }
}

export default new FilterMapper();